import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                               from '@angular/forms';
import { TranslateService }                     from '@ngx-translate/core';

import { CountriesService }  from './countries.service';
import { CountryTypesModel } from '../sessions/models/session.country-types';
import { MessagesService }   from '../messages/messages.service';
import { StateTypeModel }    from './typings/countries.state-type';

@Component({
  selector   : 'wor-new-state-type',
  template: require('./countries.new-state-type.component.html')
})
export class NewStateTypeComponent {
  @BlockUI('newStateTypeBlock') block : NgBlockUI;

  @Input() country : CountryTypesModel;

  state = {} as StateTypeModel;

  constructor (
    public  activeModal      : NgbActiveModal,
    @Inject(forwardRef(() => CountriesService))
    private countriesService : CountriesService,
    private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  submit ( form : NgForm ) : void {
    this.block.start();

    this.state.country_code = this.country.code;

    this.countriesService.createStateType(this.state)
    .then(( state : StateTypeModel ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.STATE_ADDED_TO_COUNTRY'), 'success');

      this.activeModal.close(state);
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
